import ReactDOM from "react-dom";
import debounce from "lodash/debounce";

import CanvasHandler from "./CanvasHandler";

class TooltipHandler {
  canvasHandler: CanvasHandler;
  tooltipEl: HTMLDivElement;

  constructor(canvasHandler: CanvasHandler) {
    this.canvasHandler = canvasHandler;
    this.initialize();
  }

  /**
   * Initialize tooltip
   *
   * @author salgum1114
   */
  public initialize() {
    this.tooltipEl = document.createElement("div");
    this.tooltipEl.id = `${this.canvasHandler.id}_tooltip`;
    this.tooltipEl.className = "rde-tooltip tooltip-hidden";
    document.body.appendChild(this.tooltipEl);
  }

  /**
   * Destroy tooltip
   *
   * @author salgum1114
   */
  public destroy() {
    if (this.tooltipEl) {
      document.body.removeChild(this.tooltipEl);
    }
  }

  /**
   * Show tooltip
   *
   * @param {FabricObject} [target]
   */
  public show = debounce(async (e: any, htmlElement?: any) => {
    while (this.tooltipEl.hasChildNodes()) {
      this.tooltipEl.removeChild(this.tooltipEl.firstChild);
    }

    if (!htmlElement) return;

    const tooltip = document.createElement("div");
    tooltip.className = "rde-tooltip-show";
    tooltip.innerHTML = htmlElement;
    this.tooltipEl.appendChild(tooltip);
    ReactDOM.render(htmlElement, tooltip);
    this.tooltipEl.classList.remove("tooltip-hidden");

    let clientX;
    let clientY;

    if (e.changedTouches && e.changedTouches.length > 0) {
      // Mobile
      clientX = e.changedTouches[0].clientX;
      clientY = e.changedTouches[0].clientY;
    } else {
      // Desktop
      clientX = e.clientX;
      clientY = e.clientY;
    }

    const left = clientX;
    const top = clientY;

    const space = 10;
    if (document.body.clientWidth <= left + this.tooltipEl.offsetWidth) {
      this.tooltipEl.style.left = `${left -
        this.tooltipEl.offsetWidth -
        space}px`;
    } else {
      this.tooltipEl.style.left = `${left + space}px`;
    }

    if (document.body.clientHeight <= top + this.tooltipEl.offsetHeight) {
      this.tooltipEl.style.top = `${top -
        this.tooltipEl.offsetHeight -
        space}px`;
    } else {
      this.tooltipEl.style.top = `${top + space}px`;
    }
  }, 100);

  /**
   * Hide tooltip
   * @param {fabric.Object} [_target]
   */
  public hide = debounce(() => {
    if (this.tooltipEl) {
      this.tooltipEl.classList.add("tooltip-hidden");
    }
  }, 0);
}

export default TooltipHandler;
